import { RootState } from 'app/store';
import {
  selectRow,
  selectRowByIdAndComponentId
} from 'features/row-selection/rowSelectionSlice';
import { FC, HTMLProps } from 'react';
import { useSelector, useDispatch } from 'react-redux';

export const PaginationTableRowSelectionCheckbox: FC<
  {
    componentId: string;
    rowId: string;
    rowData: any;
  } & HTMLProps<HTMLInputElement>
> = ({
  componentId,
  rowId,
  rowData,
  className = '',
  ...rest
}: {
  componentId: string;
  rowId: string;
  rowData: any;
} & HTMLProps<HTMLInputElement>) => {
  const dispatch = useDispatch();

  const selectedRow = useSelector((state: RootState) =>
    selectRowByIdAndComponentId(state, componentId)(rowId)
  );

  return (
    <input
      type="checkbox"
      className={className + ' cursor-pointer'}
      checked={!!selectedRow}
      onChange={() => {
        dispatch(
          selectRow({
            componentId,
            selectedRow: {
              rowId,
              rowData
            }
          })
        );
      }}
      {...rest}
    />
  );
};
